import React from 'react';
import { useField } from 'formik';
import FieldWrapper from './wrapper/FieldWrapper';
import ErrorWrapper from './wrapper/ErrorWrapper';

const TextField = (props) => {
  const [field, meta] = useField(props);
  return (
    <FieldWrapper htmlFor={props.name}>
      <strong>{props.label}</strong>
      <input
        id={props.name}
        {...field}
        {...props}
      />
      { meta.touched && meta.error &&
        <ErrorWrapper name={props.name}>
          {meta.error}
        </ErrorWrapper>
      }
    </FieldWrapper>
  );
}

export default TextField;
